import {
  faArrowRight,
  faSearch,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  defaultGapping,
  defaultLayouts,
  GSEmptyList,
  GSInput,
} from "golfstatus_react_components";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  selectFlights,
  selectLeaderboard,
  selectLeaderboards,
} from "../../reducers/leaderboardSlice";
import { useNavigate } from "react-router-dom";
import { getRouting } from "../../helpers/Converters";
import { eventBaseRoute } from "../../routes/event";
import { getDateTimeOn } from "../../helpers/Dates";
import { useTournament } from "../../hooks/tournamentHooks";
import LeaderboardResultList from "../events/event/leaderboards/leaderboard-results-list";

const LeaderboardWidget = (props) => {
  const { hideSearch, readOnly } = props;
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const tournament = useTournament();
  const leaderboards = useSelector(selectLeaderboards);
  const currentLeaderboard = useSelector(selectLeaderboard);
  const tournamentFlights = useSelector(selectFlights);
  const currentFlights = tournamentFlights?.filter?.(
    (f) =>
      f.leaderboardTypeSetting?.id ===
      currentLeaderboard?.leaderboardTypeSetting?.id
  );

  const selectTeam = (team) => {
    const key = team?.teamKey ?? team?.teamKeys?.[0];
    navigate(
      getRouting(eventBaseRoute, [
        tournament?.publicUrl,
        "leaderboards",
        currentLeaderboard?.id,
        "results",
        key,
      ])
    );
  };

  const getEmptyListMessage = () => {
    if (currentLeaderboard?.id) {
      return (
        <GSEmptyList
          title={currentLeaderboard.name}
          detail={`This leaderboard does not yet have results to show.`}
          actions={
            leaderboards?.length > 0
              ? [
                  {
                    title: "Change Leaderboard",
                    type: "grey",
                    rightIcon: faArrowRight,
                    onClick: () => {
                      navigate("select");
                    },
                  },
                ]
              : []
          }
        />
      );
    }
    return (
      <GSEmptyList
        title="No Leaderboards Yet"
        detail={`Leaderboards will become available just before the tournament starts${
          tournament?.startAt ? ` at ${getDateTimeOn(tournament?.startAt)}` : ""
        }.`}
        actions={[
          {
            title: "View Event Details",
            type: "grey",
            onClick: () => {
              navigate(getRouting(eventBaseRoute, [tournament?.publicUrl]));
            },
          },
        ]}
      />
    );
  };

  const getEmptySearchMessage = () => {
    return (
      <GSEmptyList
        title="We couldn’t find who you’re looking for…"
        detail="Try changing the search term."
        actions={[
          {
            title: "Clear Search",
            type: "grey",
            onClick: () => {
              setSearch("");
            },
          },
        ]}
      />
    );
  };

  return (
    <div
      style={{
        ...defaultGapping.xxLargeGap,
        ...defaultLayouts.vStack.align("flex-start", "flex-start"),
        ...defaultLayouts.fullWidth,
      }}
    >
      {currentLeaderboard?.scores?.length > 0 && !hideSearch ? (
        <GSInput
          textValue={search}
          rightIconClick={() => {
            setSearch("");
          }}
          placeholder="Search Players..."
          onChange={(e) => {
            setSearch(e?.target?.value);
          }}
          rightIcon={faTimesCircle}
          leftIcon={faSearch}
          style={{ width: "100%", maxWidth: "400px" }}
        />
      ) : null}

      <LeaderboardResultList
        itemSelected={(team) => {
          if (team?.skin) {
            return;
          }
          selectTeam(team);
        }}
        leaderboard={currentLeaderboard}
        flights={currentFlights}
        readOnly={readOnly}
        search={search}
        emptyMessage={
          search !== "" ? getEmptySearchMessage() : getEmptyListMessage()
        }
      />
    </div>
  );
};

export default LeaderboardWidget;
